module.exports = __webpack_public_path__ + "static/durazno7-9751c4ed87dd4d8e517fd72c8089422f.jpg";